import { render, staticRenderFns } from "./TamanioCombobox.vue?vue&type=template&id=40215cb0&scoped=true&"
import script from "./TamanioCombobox.vue?vue&type=script&lang=js&"
export * from "./TamanioCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40215cb0",
  null
  
)

export default component.exports